import React from "react";
import {useParams} from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import {useThemeStore} from "../../../stores/themeStore";
import {useListingDetail} from "./useListingDetail";
import {ListingDetail} from "./ListingDetail";
import "./ListingDetail.scss";

export function ListingDetailPage() {
    const {id} = useParams()
    const theme = useThemeStore((state) => state.theme)
    const {listing, loading, error} = useListingDetail(id)

    return (
        <div className="listing-detail-page" data-theme={theme}>
            {loading && <div className="ld-center"><CircularProgress/></div>}
            {!loading && error && <div className="ld-center ld-error">Couldn’t load this listing.</div>}
            {!loading && !error && listing && <ListingDetail listing={listing}/>}
            {!loading && !error && !listing && <div className="ld-center">Listing not found.</div>}
        </div>
    )
}
